export const adult = (citizenshipId = null) => ({
    prefix: null,
    firstName: null,
    lastName: null,
    citizenshipId,
    type: 'adult',
    phone: null,
    email: null,
    birthdate: null,
    passport: {
        type: null,
        number: null,
        issueDate: null,
        expiryDate: null,
    },
})

export const child = (citizenshipId = null, age) => ({
    prefix: null,
    firstName: null,
    lastName: null,
    citizenshipId,
    birthdate: null,
    age,
    type: 'child',
    phone: null,
    passport: {
        type: null,
        number: null,
        issueDate: null,
        expiryDate: null,
    },
})
